import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollRestoration } from 'react-router-dom';

export function Layout() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const showFooter = location.pathname !== '/ai-trip';

  return (
    <div className="min-h-screen">
      <Header />
      <main className={isHomePage ? '' : 'min-h-[calc(100vh-var(--spacing)*45)]'}>
        <Outlet />
      </main>
      {showFooter && <Footer />}
      <ScrollRestoration />
    </div>
  );
}

